/* eslint-disable */
import React, { Component } from 'react'
import { ScrollView, Text, KeyboardAvoidingView, Image, View } from 'react-native'
import { connect } from 'react-redux'
import { NavigationActions } from 'react-navigation'
import UserActions from '../Redux/UserRedux'
import AuthActions from '../Redux/AuthRedux'
import ReloginActions from '../Redux/ReloginRedux'
import BaseScreen from './BaseScreen'
import { Images } from '../Themes'
// Add Actions - replace 'Your' with whatever your reducer is called :)
// import YourActions from '../Redux/YourRedux'

// Styles
import styles from './Styles/SplashScreenStyle'


class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static navigationOptions = {
    header: null
  }

  componentDidMount() {


  }


  componentDidUpdate(nextProps) {



  }

  render() {
    console.log("render splash screen")
    return (
      <View style={styles.loader}>
        <Image style={styles.image} source={Images.splashLogo} />
      </View>

    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  fetching: state.relogin.fetching
})

const mapDispatchToProps = (dispatch) => {
  return {
    readUser: UserId => dispatch(UserActions.readRequest(UserId)),

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen)
